import { useContext } from 'react';

import { OptimizeContext } from './optimize';

const useOptimizeConfig = () => {
    const { optimizeConfig } = useContext(OptimizeContext);

    return optimizeConfig;
};

export default useOptimizeConfig;